// Changelog data structure
export const changelogEntries = [
  {
    id: '0.12.0',
    version: '0.12.0',
    date: '2025-05-23',
    title: 'Gemini AI Integration & Size Charts Creator',
    type: 'minor',
    description: 'Major feature release with full Gemini AI support and new size charts functionality:',
    changes: [
      'Full Gemini AI integration for all template types (text and image processing)',
      'Multiple image selection support for Gemini vision models (up to 3 images)',
      'New Size Charts Creator with AI-powered generation and customization',
      'Enhanced AI model management with provider-specific optimizations',
      'Improved image template processing with better error handling',
      'Updated landing page to reflect Gemini availability',
      'Enhanced credit system for multi-provider AI usage',
      'Better response handling for different AI model formats',
      'Comprehensive logging and debugging improvements'
    ]
  },
  {
    id: '0.11.1',
    version: '0.11.1',
    date: '2025-05-11',
    title: 'Template Execution & Image Export Improvements',
    type: 'patch',
    description: 'Enhanced template execution and image export functionality:',
    changes: [
      'Added template execution tool integration for more efficient content generation',
      'Improved image handling in export services with better image preloading',
      'Enhanced logging for better debugging and troubleshooting',
      'Fixed image loading issues in html2canvas exports',
      'Improved error handling in template execution',
      'Updated dependencies to latest versions',
      'Improved performance of image-heavy operations'
    ]
  },
  {
    id: '0.11.0',
    version: '0.11.0',
    date: '2025-04-26',
    title: 'Image Analyzing Templates',
    type: 'minor',
    description: 'Added new Image Analyzing template feature and improved landing page:',
    changes: [
      'New Image Analyzing template feature with OpenAI Vision API integration',
      'Image selection component for analyzing product images',
      'Result preview panel for displaying AI-generated image analysis',
      'Credit system for image processing (1 credit per processed image)',
      'Credit refund mechanism for failed image processing',
      'Improved landing page to better represent the app\'s features',
      'Enhanced template system to support image analysis templates',
      'Direct OpenAI API integration for reliable image processing'
    ]
  },
  {
    id: '0.10.1',
    version: '0.10.1',
    date: '2025-04-05',
    title: 'Enhanced Image System & Credit Management',
    type: 'patch',
    description: 'Improved user experience and reliability:',
    changes: [
      'Upgraded image system to use Shopify GraphQL for better reliability',
      'Enhanced credit system to charge per image instead of per product',
      'Added automatic credit refunds when image processing fails',
      'Improved error handling during image uploads',
      'Fixed various issues with bulk image processing'
    ]
  },
  {
    id: '0.10.0',
    version: '0.10.0',
    date: '2025-04-02',
    title: 'Payment System & Tracking Update',
    type: 'minor',
    description: 'Payment System & Tracking Update with the following features:',
    changes: [
      'Added version tracking and changelog system',
      'Enhanced payment history with comprehensive Stripe billing information',
      'Fixed flex credit purchase redirects',
      'Improved variant handling with better option values extraction',
      'Added responsive navigation for all device sizes'
    ]
  },
  {
    id: '0.9.1',
    version: '0.9.1',
    date: '2025-03-15',
    title: 'Bug Fix Release',
    type: 'patch',
    description: 'Bug fixes and performance improvements:',
    changes: [
      'Fixed flex credit purchase redirect issue',
      'Enhanced payment processing with better error handling',
      'Improved server logging for payment transactions',
      'Fixed variant creation issues with option values',
      'Optimized product loading performance'
    ]
  },
  {
    id: '0.9.0',
    version: '0.9.0',
    date: '2025-02-20',
    title: 'Feature Enhancement',
    type: 'minor',
    description: 'New features and enhancements:',
    changes: [
      'Added subscription plan comparison page',
      'Enhanced user dashboard with new metrics',
      'Improved template management system',
      'Added advanced product filtering options',
      'Enhanced bulk editing capabilities',
      'Added support for custom product fields',
      'Improved SEO optimization features',
      'Added product analytics dashboard',
      'Enhanced image optimization tools',
      'Added automated backup system',
      'Improved user onboarding flow',
      'Added multi-language support framework',
      'Enhanced API rate limiting',
      'Added advanced search capabilities',
      'Improved data export functionality',
      'Added custom webhook support',
      'Enhanced security measures',
      'Added performance monitoring tools',
      'Improved error tracking and reporting',
      'Added advanced user permissions',
      'Enhanced template sharing features',
      'Added automated testing framework',
      'Improved database optimization',
      'Added real-time collaboration features',
      'Enhanced mobile app performance',
      'Added advanced caching mechanisms',
      'Improved third-party integrations',
      'Added custom reporting tools',
      'Enhanced data visualization',
      'Added automated maintenance tasks',
      'Improved system scalability',
      'Added advanced configuration options',
      'Enhanced user experience design',
      'Redesigned dashboard with improved metrics',
      'Enhanced navigation with collapsible sidebar',
      'Added dark mode support',
      'Improved mobile responsiveness',
      'Updated all form components for better usability'
    ]
  },
  {
    id: '0.8.0',
    version: '0.8.0',
    date: '2025-01-10',
    title: 'Security Update',
    type: 'minor',
    description: 'Security enhancements and bug fixes:',
    changes: [
      'Implemented enhanced API authentication',
      'Added two-factor authentication support',
      'Enhanced data encryption protocols',
      'Improved session management',
      'Added security audit logging',
      'Enhanced password requirements',
      'Implemented rate limiting for API calls',
      'Added CSRF protection',
      'Enhanced input validation and sanitization',
      'Improved error handling to prevent information leakage',
      'Added security headers for better protection',
      'Implemented secure cookie handling',
      'Enhanced user permission system',
      'Added automated security scanning',
      'Improved data backup and recovery procedures',
      'Enhanced monitoring and alerting systems',
      'Added compliance reporting features',
      'Implemented secure file upload handling',
      'Enhanced API endpoint security',
      'Added advanced threat detection',
      'Improved user activity tracking',
      'Enhanced data privacy controls',
      'Added secure communication protocols',
      'Implemented automated security updates',
      'Enhanced vulnerability management',
      'Added security training resources',
      'Improved incident response procedures',
      'Enhanced access control mechanisms',
      'Added security configuration management',
      'Implemented advanced product filtering',
      'Added bulk tagging capabilities',
      'Enhanced product variant management',
      'Added support for metafield editing',
      'Implemented product import/export functionality'
    ]
  },
  {
    id: '0.7.0',
    version: '0.7.0',
    date: '2024-11-15',
    title: 'Beta Release',
    type: 'minor',
    description: 'Beta release with expanded functionality:',
    changes: [
      'Added multi-shop support',
      'Implemented template system for product editing',
      'Enhanced bulk editing capabilities',
      'Added basic subscription management',
      'Improved error handling and user feedback'
    ]
  },
  {
    id: '0.6.0',
    version: '0.6.0',
    date: '2024-10-01',
    title: 'Alpha Release 3',
    type: 'minor',
    description: 'Third alpha release with additional features:',
    changes: [
      'Added product variant management',
      'Implemented basic image handling',
      'Added user authentication system',
      'Improved Shopify API integration',
      'Enhanced user interface with Polaris components'
    ]
  },
  {
    id: '0.5.0',
    version: '0.5.0',
    date: '2024-09-15',
    title: 'Alpha Release 2 - Enhanced Features',
    type: 'minor',
    description: 'Second alpha release with enhanced features:',
    changes: [
      'Enhanced product editing capabilities',
      'Improved Shopify authentication flow',
      'Added advanced dashboard interface',
      'Enhanced product search and filtering',
      'Improved error handling and user feedback'
    ]
  },
  {
    id: '0.4.0',
    version: '0.4.0',
    date: '2024-09-01',
    title: 'Alpha Release 2',
    type: 'minor',
    description: 'Second alpha release with core improvements:',
    changes: [
      'Added basic product editing capabilities',
      'Implemented Shopify authentication',
      'Created simple dashboard interface',
      'Added product search and filtering',
      'Implemented basic error handling'
    ]
  },
  {
    id: '0.3.0',
    version: '0.3.0',
    date: '2024-08-20',
    title: 'Core Features Addition',
    type: 'minor',
    description: 'Added core product management features:',
    changes: [
      'Enhanced Shopify API integration',
      'Added product listing with pagination',
      'Implemented basic product editing',
      'Added user interface improvements',
      'Enhanced error handling and logging'
    ]
  },
  {
    id: '0.2.0',
    version: '0.2.0',
    date: '2024-08-10',
    title: 'Basic Functionality',
    type: 'minor',
    description: 'Added basic application functionality:',
    changes: [
      'Improved Shopify API connection',
      'Enhanced product listing interface',
      'Added basic navigation',
      'Implemented user authentication flow',
      'Added basic styling and layout'
    ]
  },
  {
    id: '0.1.0',
    version: '0.1.0',
    date: '2024-08-01',
    title: 'Initial Alpha Release',
    type: 'minor',
    description: 'First alpha release with basic functionality:',
    changes: [
      'Initial project setup and structure',
      'Basic Shopify API connection',
      'Simple product listing page',
      'Minimal user interface',
      'Core application framework'
    ]
  }
];

// Helper functions
export const getVersionTypes = () => {
  return [
    { label: 'All Types', value: '' },
    { label: 'Major Releases', value: 'major' },
    { label: 'Minor Releases', value: 'minor' },
    { label: 'Patch Releases', value: 'patch' }
  ];
};

export const getVersionBadge = (type) => {
  switch (type) {
    case 'major':
      return 'success';
    case 'minor':
      return 'info';
    case 'patch':
      return 'attention';
    default:
      return 'new';
  }
};

export const getLatestVersion = () => {
  if (changelogEntries.length === 0) return null;
  
  // Sort by version number (assuming semantic versioning)
  const sorted = [...changelogEntries].sort((a, b) => {
    const aParts = a.version.split('.').map(Number);
    const bParts = b.version.split('.').map(Number);
    
    for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
      const aVal = i < aParts.length ? aParts[i] : 0;
      const bVal = i < bParts.length ? bParts[i] : 0;
      
      if (aVal !== bVal) {
        return bVal - aVal; // Descending order
      }
    }
    
    return 0;
  });
  
  return sorted[0];
};

/*
* HOW TO ADD A NEW RELEASE TO THE CHANGELOG:
* 
* 1. Update the version in package.json
* 2. Add a new entry at the TOP of the changelogEntries array with the following structure:
* 
* {
*   id: '0.9.5', // Same as version, used as unique identifier
*   version: '0.9.5', // Version number (following semantic versioning)
*   date: '2025-04-15', // Release date in YYYY-MM-DD format
*   title: 'Bug Fix Release', // Short descriptive title
*   type: 'patch', // Type: 'major', 'minor', or 'patch'
*   description: 'Bug fixes and performance improvements:', // Brief description
*   changes: [ // Array of specific changes
*     'Fixed issue with product variant creation',
*     'Improved loading performance',
*     'Updated dependencies to latest versions',
*     'Enhanced error handling',
*     'Fixed UI issues on mobile devices'
*   ]
* }
* 
* 3. The changelog page will automatically display the new version
* 4. The version badge in the navigation will automatically update
*/
